<template>
	<div class="card border-0 bg-light">
		<div class="card-body">

			<div class="row gx-3 align-items-center mb-4">
				<div class="col">
					<input type="text"
						   class="form-control filter-price-input"
						   :id="id+'_cleave_from'"
					/>
				</div>
				<div class="col-1 text-center">-</div>
				<div class="col">
					<input type="text"
						   class="form-control filter-price-input"
						   :id="id+'_cleave_to'"
					/>
				</div>
			</div>

			<MultiRangeSlider
				baseClassName="multi-range-slider-bar-only"
				:min="min"
				:max="max"
				:step="step"
				:ruler="false"
				:label="false"
				:minValue="from"
				:maxValue="to"
				@input="updateValues"
			/>

		</div>
	</div>
</template>

<script>
import Cleave from 'cleave.js';

import mixins from './mixins'

import MultiRangeSlider from "multi-range-slider-vue";

export default {

	mixins: [mixins],

	components: {
		MultiRangeSlider,
	},

	props: {
		from: Number,
		to: Number,
		min: Number,
		max: Number,
		id: String,
		step: Number,
		cleaveOptions: Object,
	},

	emits: ['update:from', 'update:to'],

	data() {
		return {
			cleaveFrom: null,
			cleaveTo: null,
		}
	},

	mounted () {
		this.cleaveFrom = new Cleave('#'+this.id+'_cleave_from', {
			...this.cleaveOptions,
			numericOnly: true,
			onValueChanged: (e) => {
				this.$emit('update:from', parseInt(e.target.rawValue))
			}
		});
		this.cleaveFrom.setRawValue(this.from)

		this.cleaveTo = new Cleave('#'+this.id+'_cleave_to', {
			...this.cleaveOptions,
			numericOnly: true,
			onValueChanged: (e) => {
				this.$emit('update:to', parseInt(e.target.rawValue))
			}
		});
		this.cleaveTo.setRawValue(this.to)
	},

	watch: {
		from () {
			this.cleaveFrom.setRawValue(this.from)
		},
		to () {
			this.cleaveTo.setRawValue(this.to)
		}
	},

	methods: {
		updateValues (e) {
			this.$emit('update:from', e.minValue)
			this.$emit('update:to', e.maxValue)
		},
	}
}
</script>
